export enum ToolTypeEnum {
  MapClick = 'MapClick',
  Draw = 'Draw',
  MousePosition = 'MousePosition',
  ScaleBar = 'ScaleBar',
  Select = 'Select',
  Modify = 'Modify',
}
